import { supabase } from './supabase';

const PENDING_INVITE_KEY = 'ame_pending_invite_key';

export type InviteClaimResult = {
  claimed: boolean;
  role: string | null;
  token_limit: number | null;
  reason: string;
};

export const getPendingInviteKey = (): string => localStorage.getItem(PENDING_INVITE_KEY) ?? '';

export const savePendingInviteKey = (key: string) => {
  const trimmed = key.trim();
  if (trimmed) localStorage.setItem(PENDING_INVITE_KEY, trimmed);
};

export const clearPendingInviteKey = () => localStorage.removeItem(PENDING_INVITE_KEY);

// Claims that can still succeed later (email not verified yet, or no session) keep the key stored.
const RETRYABLE_REASONS = new Set(['email_not_verified', 'not_authenticated']);

export const isFinalClaimReason = (reason: string | undefined) => !!reason && !RETRYABLE_REASONS.has(reason);

export const redeemInviteKey = async (key: string): Promise<InviteClaimResult | null> => {
  const { data, error } = await supabase.rpc('auto_claim_tester_invitation', { p_invite_key: key });
  if (error) throw error;
  const result = (data?.[0] ?? null) as InviteClaimResult | null;
  if (result && (result.claimed || isFinalClaimReason(result.reason))) clearPendingInviteKey();
  return result;
};

export const claimPendingInvite = async (): Promise<InviteClaimResult | null> => {
  const key = getPendingInviteKey();
  if (key) return redeemInviteKey(key);
  const { data, error } = await supabase.rpc('auto_claim_tester_invitation');
  if (error) throw error;
  return (data?.[0] ?? null) as InviteClaimResult | null;
};
